// extracted by mini-css-extract-plugin
export var inlineLink = "_4i-0";
export var inlineLinkButton = "_4i-1";